import { useQuery } from "@tanstack/react-query";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import { listCallRecordings } from "./callRecordingsApi";

export const callRecordingsKey = "call-recordings";

export function useCallRecordings(numbers: string[]) {
  const dateTo = dayjs().format(ISO_DATE_FORMAT);
  const dateFrom = dayjs().subtract(1, "year").format(ISO_DATE_FORMAT);

  const { data, isLoading, error } = useQuery({
    queryKey: [callRecordingsKey, { numbers, dateFrom, dateTo }],
    queryFn: ({ signal }) => listCallRecordings(numbers, dateFrom, dateTo, signal),
  });

  return { recordings: data ?? [], isLoading, error };
}
